export const BUSINESS = {
  name: "Creative Prints",
  tagline_en: "Complete Printing Solutions",
  tagline_kn: "ಸಂಪೂರ್ಣ ಪ್ರಿಂಟಿಂಗ್ ಪರಿಹಾರಗಳು",
  phone: "+916363032874",
  phoneDisplay: "+91 63630 32874",
  whatsapp: "916363032874",
  email: "orders@creativeprints.in",
  address: "108, Bloomfield Garden, Ramachandrapura Main Rd, Chamundeswari Layout, Vidyaranyapura, Bengaluru, Karnataka 560097",
  hours_en: "Mon – Sat: 9:00 AM – 9:00 PM · Sun: 10:00 AM – 4:00 PM",
  hours_kn: "ಸೋಮ – ಶನಿ: ಬೆಳಿಗ್ಗೆ 9 – ರಾತ್ರಿ 9 · ಭಾನುವಾರ: ಬೆಳಿಗ್ಗೆ 10 – ಸಂಜೆ 4",
  areas: [
    "Vidyaranyapura", "Yelahanka", "Hebbal", "Peenya", "New BEL Road",
    "Jakkur", "Sahakarnagar", "Mathikere", "Bengaluru Doorstep Delivery",
  ],
};

export const waLink = (text) =>
  `https://wa.me/${BUSINESS.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
